module.exports = __webpack_public_path__ + "img/logo.5aed33ff.png";